
import { useEffect, useState } from 'react'
import { BriefcaseBusiness, Plus, XIcon } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddPopup from '../list/add-popup'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import AddVendorPopup from '../vendor/add-popup'
import AddRepairPopup from '../repair/add-popup'
import AddConsumablesPopup from '../consumables/add-popup'

const OfficeAssetsInvPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, tabIndex }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const [dropdowns, setDropdowns] = useState({})

    const apiCall = useApiCall();

    const handleNavClick = (index) => {
        setNavIndex(index);
    };

    const navItems = [
        { label: "Office Assets", icon: <Plus size="1.2em" /> },
        { label: "Repair Log", icon: <Plus size="1.2em" /> },
        { label: "Consumables", icon: <Plus size="1.2em" /> },
        { label: "Vendors", icon: <BriefcaseBusiness size="1.2em" /> },
    ];

    const getDropdowns = async() => {
        try {
            const apiRes = await apiCall({method: "get", url: "office-asset/dropdown"});
            setDropdowns(apiRes)
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        getDropdowns();
    }, [])

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <div className={Style.modal_header}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => {
                                    console.log("object", tabIndex, navIndex, i)

                                    return (
                                        <li
                                            key={i}
                                            className={`${navIndex === i ? Style.active : ""} ${tabIndex ? navIndex === i ? "" : Style.disabled : ""}`}
                                            onClick={() => {
                                                if (tabIndex) {
                                                    if (!navIndex === i) {
                                                        handleNavClick(i);
                                                    }
                                                } else {
                                                    handleNavClick(i);
                                                }
                                            }}
                                        >
                                            <div className={Style.icon}>{item.icon}</div>
                                            <span>{item.label}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                        {/* <div
                            className={Style.close_btn}
                            style={{
                                position: 'absolute',
                                top: '-16px',
                                right: '-16px'
                            }}
                            onClick={() => { onClose() }}
                        ><XIcon size={'1em'} /></div> */}
                    </div>

                    {
                        navIndex === 0 && (
                            <AddPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 1 && (
                            <AddRepairPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 2 && (
                            <AddConsumablesPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                dropdowns={dropdowns}
                                Style={Style}
                            />
                        )
                    }

                    {
                        navIndex === 3 && (
                            <AddVendorPopup
                                onClose={onClose}
                                onError={onError}
                                onSubmit={onSubmit}
                                currentData={currentData}
                                Style={Style}
                            />
                        )
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default OfficeAssetsInvPopup
